import { render, staticRenderFns } from "./CategoryOptionSelector.vue?vue&type=template&id=e81dc2ac&scoped=true&"
import script from "./CategoryOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./CategoryOptionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryOptionSelector.vue?vue&type=style&index=0&id=e81dc2ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81dc2ac",
  null
  
)

export default component.exports